module.exports = __webpack_public_path__ + "img/symbol_10_x25.f091efa0.png";